/* eslint-disable @typescript-eslint/no-explicit-any, no-param-reassign, no-shadow */
import { createI18n } from 'vue-i18n';
import merge from 'lodash/merge';

import { DEFAULTS } from '@constants/defaults';
import { LOCAL_STORAGE_KEYS } from '@constants/local-storage-constants';
import { kebabToCamel } from '@scripts/utils/string-utils';

const i18n = createI18n({
  legacy: false,
  locale: DEFAULTS.USER.LOCALE,
  fallbackLocale: 'en',
  messages: {},
});

const loadLocaleMessages = async (locale: string): Promise<void> => {
  const context = require.context('./locales', true, /\.json$/);
  let messages: Record<string, any> = {};

  const fullPaths = context.keys().filter(
    (path) => path.startsWith(`./${locale}/`) && path.endsWith('.json'),
  );
  const paths = fullPaths.map((path) => path.replace(`./${locale}/`, ''));

  paths.forEach(
    (path, index) => {
      const segments = path
        .split('/')
        .map((segment) => segment.replace('.json', ''));
      if (segments.length === 0) return;

      const data = context(fullPaths[index]);

      const subMessages = segments.reduceRight(
        (result, segment) => ({
          [kebabToCamel({ target: segment })]: result,
        }),
        data,
      );
      messages = merge({}, messages, subMessages);
    },
  );

  i18n.global.setLocaleMessage(locale, messages);
};

export const setLocale = async (locale: string): Promise<void> => {
  if (!i18n.global.availableLocales.includes(locale)) {
    await loadLocaleMessages(locale);
  }

  i18n.global.locale.value = locale;
  localStorage.setItem(LOCAL_STORAGE_KEYS.LOCALE, locale);
};

export const loadLocale = async () => {
  const locale = await (
    localStorage.getItem(LOCAL_STORAGE_KEYS.LOCALE) || DEFAULTS.USER.LOCALE
  );
  await setLocale(locale);
};

export default i18n;
